// SPS tenant light theme — colors sourced from Figma "Southern Pipe" design file (SPS Light mode).
import { createTheme } from '@mui/material/styles';
import './tokens';

const spsTheme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      // Brand Vermillion (PMS 179C) per SPS Brand Guidelines — was the Figma coral #F75E56.
      main: '#E4392F',
      contrastText: '#ffffff',
    },
    navigation: {
      background:        '#3d434b',
      // Brand Off-White (guideline) — was #f7f8f9.
      subPanelBg:        '#FDFCF8',
      divider:           'rgba(255, 255, 255, 0.2)',
      // was #f7433a — 3.61:1 behind the white NavBar pill label. Now 5.03:1.
      tabSelectedBg:     '#D22F23',
      tabSelectedBorder: '#ffffff',
      // Brand red tinted onto subPanelBg; subPanelText reads 10.42:1 here,
      // where the solid red gave 3.71:1.
      itemSelectedBg:    '#F7DDDC',
      // was #f7433a — 3.39:1 on subPanelBg. Now 4.73:1.
      link:              '#D22F23',
      badge:             '#f73a5b',
      text:              '#ffffff',
      textMuted:         'rgba(255, 255, 255, 0.7)',
      subPanelText:      '#2a2e42',
      // was 0.6 — 3.75:1 on subPanelBg. Now 5.79:1.
      subPanelTextMuted: 'rgba(42, 46, 66, 0.75)',
      subPanelAvatarBg:  '#d9dce0',
    },
    surface: {
      // Brand Off-White (guideline) — was #f7f8f9.
      appBackground:    '#FDFCF8',
      chatPanelBg:      '#ffffff',
      chatHeaderBg:     '#ffffff',
      inputBg:          '#ffffff',
      inputBorder:      '#d9dce0',
      inputBorderFocus: '#f7433a',
      inputText:        '#2a2e42',
      divider:          'rgba(0, 0, 0, 0.08)',
      primaryText:      '#2a2e42',
      // was #8e97a3 — 2.96:1 on white. Now 5.72:1.
      secondaryText:    '#5F6773',
      emptyStateIcon:   '#8e97a3',
      toastBg:          '#3d434b',
      toastText:        '#ffffff',
    },
    chat: {
      userBubbleBg:          '#ECEEF0',
      userBubbleText:        '#2A2E42',
      assistantBubbleBg:     '#D9DCE0',
      assistantBubbleBorder: '#D9DCE0',
      bubbleText:            '#2A2E42',
      // was #9AA0A6 — 2.64:1 on white. Now 6.05:1.
      sentStatus:            '#5F6368',
      // Darker than the default theme's #B45309 because this theme's bubbles
      // are grey (#D9DCE0), not white: #B45309 measured only 3.65:1 there.
      // #8A3D00 gives 5.55:1 on the bubble and 7.64:1 on the panel.
      mentionText:           '#8A3D00',
      reactionAction:        '#8E97A3',
      reactionActionHover:   '#E4392F',
      systemBubbleBg:        '#D9DCE0',
    },
  },
  typography: {
    // SPS brand font (guideline) — Montserrat. Other tenants keep Proxima Nova.
    fontFamily: "'Montserrat', sans-serif",
    // Heavy headers stand in for the guideline's Avenir Next Heavy (Montserrat-only decision).
    h1: { fontWeight: 800 },
    h2: { fontWeight: 800 },
    h3: { fontWeight: 800 },
    h4: { fontWeight: 800 },
    h5: { fontWeight: 800 },
    h6: { fontWeight: 800 },
  },
});

export default spsTheme;
